import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { OptOutService } from '@evermile/communications-external';

@Component({
  selector: 'ect-unsubscribe-page',
  templateUrl: './unsubscribe-page.component.html',
  styleUrls: ['./unsubscribe-page.component.scss'],
})
export class UnsubscribePageComponent implements OnInit {
  status: 'PENDING' | 'SUCCESS' | 'ERROR' = 'PENDING';

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private optOutService: OptOutService,
  ) {}

  ngOnInit(): void {
    const token = this.getTokenFromUrl();
    if (token) {
      this.authService.setIdToken(token);
      this.optOutService.optOutPost().subscribe(
        () => {
          this.status = 'SUCCESS';
        },
        () => {
          this.status = 'ERROR';
        },
      );
    }
  }

  private getTokenFromUrl() {
    return this.route.snapshot.paramMap.get('token');
  }
}
